import { create } from "zustand";

export const ProdutionStore = create((set) => ({
  naturezaImage: null,

  areaMin: 0.0,
  areaMax: 10000000.0,
  prodMin: 0.0,
  prodMax: 10000000.0,

  setNaturezaImage: (img) => set({ naturezaImage: img }),

  setAreaMin: (val) => set({ areaMin: val }),
  setAreaMax: (val) => set({ areaMax: val }),
  setProdMin: (val) => set({ prodMin: val }),
  setProdMax: (val) => set({ prodMax: val }),

  mapImage2: null,

  setMapImage2: (img) => set({ mapImage2: img }),
}));
